import { TIMESTAMP_TYPES, TIMESTAMP_TYPE_CREATED_AT } from '~/vue_shared/components/resource_lists/constants';
import GroupsListItem from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/groups_list/groups_list_item.vue?vue3';
export default {
    name: 'GroupsList',
    components: {
        GroupsListItem
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        showGroupIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        listItemClass: {
            type: [
                String,
                Array,
                Object
            ],
            required: false,
            default: ''
        },
        timestampType: {
            type: String,
            required: false,
            default: TIMESTAMP_TYPE_CREATED_AT,
            validator (value) {
                return TIMESTAMP_TYPES.includes(value);
            }
        },
        includeMicrodata: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'refetch'
    ]
};
